/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCorkedTube: {
  name: 'corked_tube';
  data: string;
} = {
  name: 'corked_tube',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M526.092 90.768 408.629 23.191c-3.867 6.69-16.903 29.372-26.468 55.919l-6.219-3.573C297.567 211.91 223.09 338.68 145.55 472.246c-23.371 40.255-14.884 88.695 18.886 108.097 33.77 19.403 80.299 2.568 103.471-37.799C344.795 408.606 419.409 281.907 498.3 145.835l-8.008-4.6c18.365-21.219 31.761-43.481 35.8-50.467zM291.275 262.87l80.573-141.009c-2.215 23.639 3.086 45.462 24.128 57.595 27.822 16.041 57.233-.82 81.161-24.192L415.651 262.87H291.275z"/></svg>`,
};
